import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";
import { submitEnquiry } from "../lib/api";

export const EnquiryForm = ({ packageName = "", compact = false, onSuccess }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    travel_date: "",
    travellers: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) {
      toast.error("Please share your name and phone number.");
      return;
    }
    setLoading(true);
    try {
      await submitEnquiry({ ...form, package: packageName, source: packageName || "website" });
      toast.success("Thank you! Our travel expert will call you shortly.");
      setForm({ name: "", phone: "", email: "", travel_date: "", travellers: "", message: "" });
      onSuccess?.();
    } catch (err) {
      toast.error("Something went wrong. Please call us at +91 98909 16767.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} data-testid="enquiry-form" className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <input data-testid="enquiry-name" className="ll-input" placeholder="Your Name*" value={form.name} onChange={update("name")} />
        <input data-testid="enquiry-phone" className="ll-input" placeholder="Phone Number*" value={form.phone} onChange={update("phone")} />
      </div>
      <div className="grid sm:grid-cols-2 gap-5">
        <input data-testid="enquiry-email" type="email" className="ll-input" placeholder="Email Address" value={form.email} onChange={update("email")} />
        <input data-testid="enquiry-date" type="text" onFocus={(e) => (e.target.type = "date")} className="ll-input" placeholder="Travel Date" value={form.travel_date} onChange={update("travel_date")} />
      </div>
      {!compact && (
        <input data-testid="enquiry-travellers" className="ll-input" placeholder="Number of Travellers" value={form.travellers} onChange={update("travellers")} />
      )}
      <textarea data-testid="enquiry-message" rows={compact ? 2 : 3} className="ll-input resize-none" placeholder="Tell us about your dream trip..." value={form.message} onChange={update("message")} />
      <button type="submit" data-testid="enquiry-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
        {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />}
        {loading ? "Sending..." : "Send Enquiry"}
      </button>
    </form>
  );
};
